import { SettingsService } from './settings/settings.service';

//To be Used by core.json_request
export class Response {
	status_code: number;
	error_type: string = null; //HttpErrorResponse

	_headers: any;
	_json: any;
	body: any;

	get headers() {
		if( !this._headers.headers ){
			this._headers.lazyInit();
		}
		return this._headers.headers;
	}

	get json(){
		if( !this._json )
			try { this._json = JSON.parse(this.body); }
			catch(e){ return null; }

		return this._json;
	}
	get ok(){ return this.status_code == 200; }

	constructor( resp ){
		this.status_code = resp.status;
		this.error_type = resp.name;
		this._headers = resp.headers;

		let content = resp.error || resp.body;
		if( typeof( content ) == "string" )
			this.body = content;
		else
			this._json = content;
	}
}

class BaseModel {
	static readonly type: string;
	get type(): string {
		return (this.constructor as typeof BaseModel).type;
	}

	sync_timestamp = 0;
	sync_outdated = false;
	constructor( kwargs, timestamp = null, instances = null ){
		if( timestamp === null )
			timestamp = (new Date()).getTime();

		this.update( kwargs, timestamp );

		if( instances === null )
			instances = this.constructor['INSTANCES']

		if( instances ) instances[this['id']] = this;
	}
	update( kwargs, timestamp ){
		for( let k of Object.keys( kwargs ) ){
			this[k] = kwargs[k];

			if( this[k] && k.endsWith('datetime') )
				this[k] = new Date(this[k]);

			if( this[k] && k.endsWith('_ids') )
				this[k] = new Set( this[k] );
		}

		this.sync_timestamp = timestamp;
		this.sync_outdated = false;
	}
	static update_or_create( m, timestamp = null, instances = null ){
		if( timestamp === null )
			timestamp = (new Date()).getTime();

		if( instances === null )
			instances = this['INSTANCES']

		let model = instances[m['id']];
		if( model )
			model.update( m, timestamp );
		else
			model = new this( m, timestamp, instances );
		return model;
	}
	static delete_outdated( instances = null ){
		if( instances === null ) instances = this['INSTANCES']

		for( let [id, model] of Object.entries(instances) ){
			if( model['sync_outdated'] )
				delete instances[id]
		}
	}

	get settings(){ return SettingsService.instance; }
}


const USER_DEFAULTS = {
	"id": "anon",
	"avatar": "/assets/placeholder_avatar_dark.png",
	"prediction_rank" : null,
	"prediction_rank_value" : null,
	"total_pending_predictions": 0,
	"total_nulled_predictions": 0,
	"total_right_predictions": 0,
	"total_wrong_predictions": 0,

	"starting_balance": "1000",
	"total_winnings": "0",
	"total_loss": "0",
	"total_unsettled": "0",
}
export class User extends BaseModel {
	static override readonly type = 'User';
	static INSTANCES = {};
	static get_anon(){
		let anon = this['INSTANCES']["anon"];
		if( anon ) return anon;
		return new User( USER_DEFAULTS );
	}
	update( kwargs, timestamp ){
		super.update( USER_DEFAULTS, timestamp );
		super.update( kwargs, timestamp );
		if( !this.predictions )
			this.predictions = {};
		if( !this.bets )
			this.bets = {};
		this.rank_calculate();
	}

	id: string; get username(){ return this.id; }
	token: string;
	avatar: string;

	predictions: any;
	prediction_rank: number;
	prediction_rank_value: number;
	total_pending_predictions: number; total_nulled_predictions: number;
	total_right_predictions: number; total_wrong_predictions: number;
	last_100_wins: number;
	get prediction_success_percentage(): number {
		try {
			return this.total_right_predictions / (this.total_right_predictions + this.total_wrong_predictions) * 100
		} catch(e){
			return 0;
		}
	}

	bets: any;
	bet_rank: number;
	starting_balance: string;
	total_winnings: string; total_loss: string; total_unsettled: string;
	get balance(){
		return (+this.starting_balance) + (+this.total_winnings) - (+this.total_loss) - (+this.total_unsettled)
	}

	tag_exempt: boolean;

	rank: { title: string; icon: string, calibration_left: number };
	rank_calculate(){
		let v = this.prediction_rank_value
		let r = this.prediction_rank
		let c = this.total_right_predictions + this.total_wrong_predictions
		let title, icon
		let over = false;

		if( c < 10 ){
			icon  = 'nature_people'
			title = 'Commoner'
			over  = true;
		} else if ( c < 25 ) {
			icon  = 'child_care'
			title = 'Newbie'
			over  = true;
		} else if( v > 40 ){
			icon  = "cake"
			title = "PieceOfCake"
		} else if( v > 5 ){
			icon  = "school"
			title = "Graduate"
		} else if( v > -1 ){
			icon  = "healing"
			title = "Ouch"
		} else {
			icon  = "pool"
			title = "AgainstTheTide"
		}

		if( !over ){
			if( r == 1 ){
				icon  = "visibility"
				title = "Oracle"

			} else if( r <= 10 ){
				title = "Masterful"

				if( r == 2 )
					icon  = "looks_two"
				if( r == 3 )
					icon  = "looks_3"
				if( r >  3 )
					icon  = "money"

			} else if( r <= 20 ){
				icon  = "face"
				title = "Apprentice"
			}
		}

		this.rank = {
			"title" :title,
			"icon"  :icon,
			"calibration_left": 100 - this.total_right_predictions - this.total_wrong_predictions,
		}
	}
}


export class Game extends BaseModel {
	static override readonly type = 'Game';
	static INSTANCES = {};

	id: number;

	away_team_id: number;
	get away_team(){ return Team.INSTANCES[this.away_team_id]; }
	home_team_id: number;
	get home_team(){ return Team.INSTANCES[this.home_team_id]; }
	get teams() { return [this.away_team, this.home_team]; }

	datetime: Date;
	start_datetime: Date;
	final_datetime: Date;
	tags: string[];
	get badges() {
		let list = [
			"G1", "G2", //Whitelist of tags shown as badges
			"G3", "G4", "G5", "G6", "G7", //NHL Playoffs
		];
		return this.tags.filter( t => list.includes(t) )
	}
	get is_unavailable(){
		return this.tags.includes("EXCLUSIVE");
	}

	status: string;
	get_status_display(){
		return  {
			"S": "Scheduled",
			"W": "Warm-up",
			"L": "Live",
			"F": "Final",
			"P": "Postponed",
			"C": "Canceled",
		}[this.status];
	}

	odds: number[];
	get away_odd(){ return this.odds && this.odds[0]; }
	get home_odd(){ return this.odds && this.odds[1]; }

	can_predict: boolean;
	can_bet: boolean;

	get is_predictable(){ return this.can_predict && "SW".includes( this.status ); }

	scores: any; //{"away": 3, "home": 4}
	get away_score(){ return this.scores["away"] || 0; }
	get home_score(){ return this.scores["home"] || 0; }


	winner: string;
	get_winner_display(){
		return {
			"U":"Unsettled",
			"H":"Home",
			"A":"Away",
		}[this.winner]
	}


	is_scored(){
		return "LF".includes( this.status );
	}
	is_spoilable(){
		if( this.status == "L" )
			return !this.settings.show_live_scores;
		if( this.status == "F" )
			return !this.settings.show_final_scores;
		return false;
	}
	are_teams_spoilable(){
		if( !"SPC".includes( this.status ) ) return false;
		if( !this.tags.includes("PF") ) return false;
		if( this.is_predictable ) return false;
		return this.settings.delete_spoilers;
	}
}


export class Team extends BaseModel {
	static override readonly type = 'Team';
	static INSTANCES = {};
	static FROMABR = {};
	constructor( kwargs, timestamp = null ){
		super( kwargs, timestamp );
		Team.FROMABR[this.abbreviation.toUpperCase()] = this;
	}


	id: number;
	name: string;
	short_name: string;
	abbreviation: string;
	color: string;
	padding: number;

	_logo: string;
	get logo(): string {
		if( this.settings.prefer_old_team_logos )
			return `/sport-assets/teams/${this.abbreviation.toUpperCase()}.svg`;
		return this._logo
	}
	set logo(v: string){ this._logo = v }

}




export class MediaEvent extends BaseModel {
	static override readonly type = 'MediaEvent';
	static INSTANCES = {};

	id: number;

	game_id: number;
	get game(){ return this.game_id && Game.INSTANCES[this.game_id]; }
	order: number;
	get_team_stars(){
		if( !this.game_id ) return;
		if( this.title.toLowerCase() == "away" )
			return this.settings.favourite_teams[this.game.away_team.abbreviation] || 0;
		if( this.title.toLowerCase() == "home" )
			return this.settings.favourite_teams[this.game.home_team.abbreviation] || 0;
		return;
	}

	provider: string;
	provider_mediaid: string;
	provider_eventid: string;

	title: string;
	description: string;

	datetime: Date;

	status: string;
	get_status_display(){
		return  {
			"P": "Planned",
			"L": "Live",
			"O": "Over",
			"R": "Replay",
			"S": "Scrapped",
		}[this.status];
	}
	get is_playable(){
		return "LOR".includes( this.status );
	}

}


export class Flavor extends BaseModel {
	static override readonly type = 'Flavor';
	static INSTANCES = {};


	id: string;
	name: string;
	entitlements: string[][];
	media_event_ids: Set<number>;

	get is_public(){
		return this.entitlements === null;
	}
}


export class Poster extends BaseModel {
	static override readonly type = 'Poster';
	static INSTANCES = {};
	update( kwargs, timestamp ){
		super.update( kwargs, timestamp );

		this.event_types = {};
		for( let event of this.events ){
			if( event.endsWith("!") )
				this.event_types[event.slice(0,-1)] = true;
			else
				this.event_types[event] = false;
		}
	}

	id: string;
	events: string[];
	event_types: any;

	order: number;
	html: string;
	image: string;

	cooldown_seconds: number;
	expiration_datetime: Date;
	activation_datetime: Date;

	get is_expired(){
		if( this.expiration_datetime === null ) return false;
		return this.expiration_datetime.getTime() < (new Date()).getTime();
	}
	get is_active(){
		return this.activation_datetime.getTime() < (new Date()).getTime();
	}

}
